export default __webpack_public_path__ + "static/media/dtmf-5.72b478ac.mp3";